var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionBottomRightRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 79,
    viewBox: "0 0 73 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3549 4.55786C71.4487 10.7678 71.307 22.5096 72.0868 32.691C72.7837 41.7889 72.0885 50.7377 67.4964 58.6295C62.3099 67.5427 55.6398 77.441 45.3972 78.5585C35.3242 79.6576 28.1549 70.0341 20.1826 63.7919C12.6607 57.9023 2.37579 53.3597 1.11043 43.8823C-0.145353 34.4768 8.38878 27.2887 14.3185 19.8712C19.8418 12.9622 25.2009 5.82742 33.6394 3.19222C43.4841 0.117824 55.1807 -1.71373 63.3549 4.55786Z",
    fill: "#B2D7F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionBottomRightRock);
export default __webpack_public_path__ + "static/media/heroSectionBottomRightRock.55062dde1ad1bbebf9e756308da17b7f.svg";
export { ForwardRef as ReactComponent };